import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  outOfServiceHospitals: [],
  allOutOfServiceHospitals: [],
  allActiveOutOfServiceHospitals: [],
  allActiveAlarmOutOfServiceHospitals: [],
  totalPages: 0,
  totalRecords: 0,
  outOfServiceHospital: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_58: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_OutOfServiceHospitals(state, outOfServiceHospitals) {
    state.outOfServiceHospitals = outOfServiceHospitals.items;
    state.totalPages = outOfServiceHospitals.totalPages;
    state.totalRecords = outOfServiceHospitals?.totalRecords ?? 0;
  },
  SET_AllOutOfServiceHospitals(state, outOfServiceHospitals) {
    state.allOutOfServiceHospitals = outOfServiceHospitals;
  },
  SET_OutOfServiceHospital(state, outOfServiceHospital) {
    state.outOfServiceHospital = outOfServiceHospital;
  },
  SET_AllActiveOutOfServiceHospitals(state, outOfServiceHospital) {
    state.allActiveOutOfServiceHospitals = outOfServiceHospital;
  },
  SET_AllActiveAlarmOutOfServiceHospitals(state, outOfServiceHospital) {
    state.allActiveAlarmOutOfServiceHospitals = outOfServiceHospital;
  },
};
const actions = {
  errorOutOfServiceHospital({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllOutOfServiceHospitals({ commit, dispatch, rootState }) {
    return apiClient
      .get('/OutOfServiceHospitals/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllOutOfServiceHospitals', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServiceHospital', error);
      });
  },
  getAllActiveOutOfServiceHospitals({ commit, dispatch, rootState }) {
    return apiClient
      .get('/OutOfServiceHospitals/AllActive', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllActiveOutOfServiceHospitals', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServiceHospital', error);
      });
  },
  getAllActiveAlarmOutOfServiceHospitals({ commit, dispatch, rootState }) {
    return apiClient
      .get('/OutOfServiceHospitals/AllActiveWithAlarm', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllActiveAlarmOutOfServiceHospitals', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServiceHospital', error);
      });
  },
  getOutOfServiceHospitalsWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, title, cityId },
  ) {
    var url =
      '/OutOfServiceHospitals/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_OutOfServiceHospitals', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServiceHospital', error);
      });
  },
  addOutOfServiceHospital({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OutOfServiceHospitals', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServiceHospital', error);
      });
  },
  extendOutOfServiceHospital({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OutOfServiceHospitals/Extend', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServiceHospital', error);
      });
  },
  modifyOutOfServiceHospital({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OutOfServiceHospitals/Modify', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServiceHospital', error);
      });
  },
  getOutOfServiceHospital({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/OutOfServiceHospitals/ById?outOfServiceHospitalId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_OutOfServiceHospital', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServiceHospital', error);
      });
  },
  editOutOfServiceHospital({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OutOfServiceHospitals/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServiceHospital', error);
      });
  },
  endOutOfServiceHospital({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/OutOfServiceHospitals/End?outOfServiceHospitalId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOutOfServiceHospital', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
